export default __webpack_public_path__ + "static/media/Yandex_grey.affe3292.svg";